export { default } from './ExpertCardMore';
